<template>
  <div class="number-box">
    <a-cascader
      v-model:value="value"
      :options="getOptions()"
      :placeholder="'请选择' + info.title"
      change-on-select
      :show-search="{ filter }"
      style="width: 100%"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { ScForm } from '@/models/ScForm';
import { AreaSearch } from '@/components/business/crud/interface/SearchType';
import {
  getArea,
  getOptions,
} from '@/components/business/crud/widgets/impl/area';

const props = defineProps<{
  propName: string;
  widget: AreaSearch;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

const value = computed({
  get() {
    if (data.value[props.propName]?.$like) {
      return getArea(
        data.value[props.propName]?.$like.slice(0, -1).padEnd(6, '0')
      ).ids;
    } else {
      return undefined;
    }
  },
  set(val?: string[]) {
    if (val) {
      data.value[props.propName] = {
        $like: val[val.length - 1].replace(/0*$/, '') + '%',
      };
      console.log('set', data.value[props.propName]);
    } else {
      data.value[props.propName] = undefined;
    }
  },
});
</script>

<style lang="scss" scoped></style>
